import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import NavBar from '../components/Navigation/NavBar';
import DevElectronSwitch from '../components/DevTools/DevElectronSwitch';

const { Content } = Layout;

const AvaApp = ({ children }) => (
  <Layout style={{ minHeight: '100vh' }}>
    <NavBar />
    <Content style={{ paddingBottom: '120px' }}>
      <Outlet />
    </Content>
    {process.env.NODE_ENV === 'development' && <DevElectronSwitch />}
  </Layout>
);

export default AvaApp;
